/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class PublicTrialsAPI extends ApiClient {
  constructor() {
    super('public/trials', { accountScoped: false });
  }

  templates() {
    return axios.get(`${this.url}/templates`);
  }

  createTrial(payload) {
    return axios.post(this.url, payload);
  }

  getStatus(token) {
    return axios.get(`${this.url}/${token}`);
  }
}

export const publicTrialsApi = new PublicTrialsAPI();
